import React, { memo, useCallback, Suspense, useEffect, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { UploadFiles } from '../../../../../../components/v2/upload-files'
import { addTimeLineItem, deleteTimeLineItem } from '../../../../../../store/timeline/actions'
import {
  selectTimelineFiles,
  ActivityItems,
  ActivityTimelineContext,
  ActivityTimeline,
  selectTimelineIsLoading,
  selectTimelineError,
  ActivityTimelineContextProps,
} from '../../../../../../components/v2/activity-timeline'
import { useAppDispatch } from '../../../../../../hooks/useAppDispatch/useAppDispatch'
import { getTimeLineFiles } from '../../../../../../store/timeline/action-creators'
import styled from 'styled-components'
import { FileManagerAsync as FileManager } from '../../../../../../components/v2/activity-file-manager/ui/file-manager.async'

const FileTabCtr = styled.div`
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

interface TabFilesProps {
  id: string | number
  className?: string
}

export const TabFiles: React.FC<TabFilesProps> = memo((props: TabFilesProps) => {
  const { id, className } = props
  const dispatch = useAppDispatch()
  const timelineFiles = useSelector(selectTimelineFiles)
  const timelineIsLoading = useSelector(selectTimelineIsLoading)
  const timelineError = useSelector(selectTimelineError)
  const entityType = 'hr_employee'
  const [timelineLoaded, setTimelineLoaded] = useState(false)

  useEffect(() => {
    if (id && id !== 'new' && !timelineLoaded) {
      dispatch(getTimeLineFiles('hr_employee', id))
      setTimelineLoaded(true)
    }
  }, [id, dispatch, timelineLoaded])

  const handleUploadSuccess = useCallback(
    (response: { group?: Array<{ date: string | number; items?: unknown[] }> }) => {
      if (response?.group?.length) {
        const formattedGroup = response.group.map(item => ({
          ...item,
          date: String(item.date),
        }))
        dispatch(addTimeLineItem(formattedGroup as ActivityItems[]))
      }
    },
    [dispatch],
  )

  const deleteCustomerTimelineItem = useCallback(activityItem => {
    dispatch(deleteTimeLineItem(activityItem))
  }, [])

  const defaultProps = useMemo(
    (): ActivityTimelineContextProps => ({
      card_id: id,
      card_type: entityType,
      deleteTimelineItem: deleteCustomerTimelineItem,
    }),
    [id],
  )

  return (
    <FileTabCtr>
      <div>
        <Suspense fallback={''}>
          <div className="file-drag">
            <UploadFiles
              entityType={entityType}
              entityId={id}
              url={`/api/hr/employees/${id}/add-file`}
              onUploadSuccess={handleUploadSuccess}
            />
          </div>
        </Suspense>
        <Suspense fallback={''}>
          <ActivityTimelineContext.Provider value={defaultProps}>
            <ActivityTimeline
              isLoading={timelineIsLoading}
              items={timelineFiles}
              error={timelineError}
              className={className}
              emptyMessage={'Нет прикрепленных файлов'}
            />
          </ActivityTimelineContext.Provider>
        </Suspense>
      </div>
      <div>
        <Suspense fallback={''}>
          <FileManager activityItems={timelineFiles} />
        </Suspense>
      </div>
    </FileTabCtr>
  )
})

TabFiles.displayName = 'TabFiles'
